import React, {Component} from 'react';

import '../style/Header.css';
import Logo from '../static/shoppertrak_logo.png';
import PropTypes from 'prop-types';
import Logout from '../static/logout.png';
import {logout} from "../state/action/apiActions";
import {connect} from 'react-redux';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    handleLogoutClick = () => {
        const {dispatch} = this.props;
        dispatch(logout);
    };

    renderLogoutTab() {
        if (this.props.authenticated) {
            return (
                <div onClick={this.handleLogoutClick} className="header__section header__right header__icon__link">
                    <img className="logout__icon" src={Logout} alt="Logout.png"/>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        return (
            <div className="header__container">
                <div className="header__section header__left">
                    <div id="header__image"><img src={Logo} alt="Logo.png"/></div>
                    <div id="header__title">
                        <div>Installation Portal {this.props.version}</div>
                    </div>
                </div>
                {this.renderLogoutTab()}
            </div>
        );
    }
}

Header.propTypes = {
    authenticated: PropTypes.bool.isRequired,
    version: PropTypes.string
};

export default connect()(Header);


// WEBPACK FOOTER //
// ./src/component/Header.jsx